/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladderstep33Inputs */

const en_letterpreviewladderstep33 = /** @type {(inputs: Letterpreviewladderstep33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Court or arbitration`)
};

const pt_letterpreviewladderstep33 = /** @type {(inputs: Letterpreviewladderstep33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tribunal ou arbitragem`)
};

/**
* | output |
* | --- |
* | "Court or arbitration" |
*
* @param {Letterpreviewladderstep33Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladderstep33 = /** @type {((inputs?: Letterpreviewladderstep33Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladderstep33Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladderstep33(inputs)
	return pt_letterpreviewladderstep33(inputs)
});
export { letterpreviewladderstep33 as "letterPreviewLadderStep3" }